import React, { useContext, useEffect } from "react";
import { useQuery } from '@apollo/client';
import './Images.scss'
import CartoucheInfos from 'components/CartoucheInfos';
import ImagesPlayer from './ImagesPlayer';
import Hidden from '@mui/material/Hidden';
import Grid from '@mui/material/Grid';
import Suggestion from 'components/Suggestion';
import Utils from 'utils/Utils';
import { SettingsContext } from 'Providers/SettingsProvider';
import Queries from 'utils/Queries';

function Images({id}) {
  const { translate, setTick } = useContext(SettingsContext);
  const { data } = useQuery(Queries.images,{
    variables: { id:parseInt(id) },
  });
  useEffect(()=>setTick(t=>t+1),[data,setTick]);
  const item=data ? data.images[0] : {};
  const cartoucheDataTop=[
    ...Utils.renderExpos(item),
    {key:'audio',value:translate(item,'name')},
    Utils.renderArtistes(item,true),
    {key:'nombre-d-images',value:item.diaporama && item.diaporama.length},
  ];
  const cartoucheDataBottom=[
    {text:translate(item,'texte')},
    {ps:translate(item,'ps')},
    Utils.renderTags(item),
  ];
  return (<div className="images">
      <div className="main-container">
          <Grid container>
              <Grid item xs={12} md={3}>
                  {data && <CartoucheInfos data={cartoucheDataTop}/>}
                  {data && <Hidden smDown><CartoucheInfos data={cartoucheDataBottom}/></Hidden>}
              </Grid>
              <Grid item xs={12} md={9}>
                  {item.diaporama && <ImagesPlayer images={item.diaporama}/>}
              </Grid>
              <Grid item xs={12}>
                  {data && <Hidden mdUp><CartoucheInfos data={cartoucheDataBottom}/></Hidden>}
              </Grid>
          </Grid>
          <Suggestion currentItem={item}/>
      </div>
  </div>);
}
export default Images;
